import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { selectUserRbacPermissions } from 'core/userContext';
import { useSelector } from 'react-redux';

export const useCanCreateGoals = () => {
  const permissions = useSelector(selectUserRbacPermissions);
  return permissions.includes(PROJECT_PERMISSIONS.ManageProjectSettings);
};
